<template>
  <div>
    <vs-card class="mb-6">
      <form role="form" @submit.stop.prevent="buscar">
        <div class="vx-row">
          <!-- Nosso Numero -->
          <div class="vx-col lg:w-1/6 w-full">
            <span>Nosso Número</span>
            <vs-input
              class="w-full"
              name="nossoNumero"
              id="nossoNumero"
              v-model="formFiltro.nossoNumero"
            />
          </div>

          <!-- Nome -->
          <div class="vx-col lg:w-1/3 w-full">
            <span>Nome Associado</span>
            <AutoComplete
              customClass="w-full"
              name="nomeAssociado"
              id="nomeAssociado"
              :configAutoComplete="{ model: 'Associados', field: 'nome' }"
              v-model="formFiltro.nomeAssociado"
            />
          </div>

          <!-- CPF / CNPJ -->
          <div class="vx-col lg:w-1/4 w-full">
            <span>CPF / CNPJ</span>
            <AutoComplete
              customClass="w-full"
              name="cpfCnpj"
              id="cpfCnpj"
              v-model="formFiltro.cpfCnpj"
              :configAutoComplete="{ model: 'Associados', field: 'cpfcnpj' }"
              :minimumCharacters="3"
            />
          </div>

          <!-- Data Pagamento -->
          <div class="vx-col lg:w-1/4 w-full">
            <span>Data Pagamento</span>
            <datepicker
              :format="'dd/MM/yyyy'"
              placeholder="DD/MM/YYYY"
              v-model="formFiltro.dataPagamento"
              :language="languages"
            ></datepicker>
          </div>
        </div>
      </form>

      <div slot="footer" style="margin-top: 3%">
        <br style="clear: both" />
        <vs-row vs-justify="flex-end">
          <!-- Buscar -->
          <vs-button
            color="success"
            type="filled"
            icon-pack="feather"
            icon="icon-search"
            class="mr-3 mb-2"
            @click="buscar"
            >Buscar</vs-button
          >

          <!-- Limpar Filtro -->
          <vs-button
            @click="limparFiltro"
            color="danger"
            type="gradient"
            icon-pack="feather"
            icon="icon-trash-2"
          ></vs-button>
        </vs-row>
      </div>
    </vs-card>
  </div>
</template>

<script>
import Datepicker from 'vuejs-datepicker';
import * as lang from 'vuejs-datepicker/src/locale';
import moment from 'moment';

import AutoComplete from '../../../../components/autocomplete/AutoComplete.vue';

const formFiltro = {
  nossoNumero: null,
  nomeAssociado: null,
  cpfCnpj: null,
  dataPagamento: null,
};

export default {
  components: {
    Datepicker,
    AutoComplete,
  },
  data() {
    return {
      languages: lang.ptBR,
      formFiltro: { ...formFiltro },
    };
  },
  methods: {
    limparFiltro() {
      this.formFiltro = { ...formFiltro };
      this.buscar();
    },
    buscar() {
      const dataPagamento = this.formFiltro.dataPagamento
        ? moment(this.formFiltro.dataPagamento).format('YYYY-MM-DD')
        : null;

      const filtro = {
        ...this.formFiltro,
        dataPagamento,
      };

      this.$emit('filtro', filtro);
    },
  },
};
</script>

<style>
.vdp-datepicker input {
  width: 100%;
}

.vdp-datepicker__calendar {
  z-index: 900 !important;
}
</style>
